/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export const semanticMatchLevels = [
  {num: 0.3, key: '1 - Slightly related'},
  {num: 0.4, key: '2 - Somewhat related'},
  {num: 0.5, key: '3 - Moderately related'},
  {num: 0.6, key: '4 - Closely related'},
  {num: 0.7, key: '5 - Very closely related'}
];

const matchLevelsReversed = _.reverse([...semanticMatchLevels]);

export function doLevelMatch(score: number): {num: number; key: string} | undefined {
  return _.find(matchLevelsReversed, (s) => {
    return score >= s.num;
  });
}
